import React from "react";
import { ArrowRight, CheckCircle } from "lucide-react"; 
import { Link } from "react-router-dom";                
import Button from "../components/Button";        

// CTA (Call To Action) Section Component
const CtaSection: React.FC = () => {
    return (
        <section className="bg-blue-900 py-20">
            <div className="max-w-4xl mx-auto px-6 text-center">

                {/* Section Heading */}
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                    Ready to Transform Your Workplace Culture?
                </h2>

                {/* Supporting Text */}
                <p className="text-lg text-blue-100 mb-8">
                    Join PowerUp to build stronger, more
                    engaged teams through meaningful recognition.
                </p>

                {/* Call-to-Action Button */}
                <Link to="/auth">
                    <Button primary>
                        Start Recognizing Today
                        {/* Arrow icon sliding animation */}
                        <ArrowRight className="w-5 h-5 animate-arrow-slide" />
                    </Button>
                </Link>

                {/* Features Row (bullet points under CTA) */}
                <div className="mt-12 flex flex-col md:flex-row items-center justify-center gap-8 text-blue-100">

                    {/* Feature: Free to start */}
                    <div className="flex items-center gap-2">
                        <CheckCircle className="w-5 h-5 text-blue-300" />
                        <span>Free to start</span>
                    </div>

                    {/* Feature: Setup in minutes */}
                    <div className="flex items-center gap-2">
                        <CheckCircle className="w-5 h-5 text-blue-300" />
                        <span>Setup in minutes</span>
                    </div>

                    {/* Feature: 24/7 Support */}
                    <div className="flex items-center gap-2">
                        <CheckCircle className="w-5 h-5 text-blue-300" />
                        <span>24/7 support</span>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CtaSection;
